package com.narbase.letsgo.web.models

import com.narbase.letsgo.dto.EnumDtoName

enum class TransferType(dtoName: String? = null) : EnumDtoName {
    BANKILY,
    SEDAD
    ;
    override val dtoName: String = dtoName ?: this.name
    companion object {

        fun String.pkgToType() : TransferType? {
            return if (this == "mr.bpm.digitalbanking.consumer") {
                BANKILY
            } else if (this == "mr.digi.sedad") {
                SEDAD
            } else null
        }
    }
}